import React from 'react'
import {teamSiteUrlFormate}  from "../../../../utils/dateFormate";
import ReactHtmlParser from 'html-react-parser';
const DreamSubMenuMobile = ({dreamSubMenuData,backNavFunc,showSubMenu, $mainMenuLinkTxt}) => {
    const {REACT_APP_IMAGEURL} = window.weeksWebCloudConfig;
    return (
        <div className={`slide-menu-container ${showSubMenu === "DREAM" ? "slide-in" : "slide-out"}`}>
        <div className="col-12 border-bottom">
            <a className="points-x-small bold py-3 d-block black-link-color" 
            href="#!" 
            onClick={backNavFunc}>
                <img src={`${REACT_APP_IMAGEURL}/static/images/rebrand-ds/Arrow-left.png`}
                alt="Back menu" 
                width="24px" height="24px"/>{$mainMenuLinkTxt}</a>
        </div>   
        <div className="px-3 pt-3">
        <div className="sub-menu-heading pb-2">{dreamSubMenuData.DisplayText}</div>
        <ul className="mobile-nav">
            {
                dreamSubMenuData.LinksInfo.Links.map((data,index)=>{
                    return(
                        <li className="py-2" key={index}>
                            <a href={teamSiteUrlFormate(data.URL)}>
                                <img src={REACT_APP_IMAGEURL+data.MobileLinkIcon} alt=""/> 
                                <span>{ReactHtmlParser(data.DisplayText)}</span>
                            </a>
                        </li>
                    )
                })
            }
             {
                dreamSubMenuData.ActivityInfo.ImageInfo.map((data,index)=>{
                    return(
                        <li className="py-2" key={index}>
                            <a href={teamSiteUrlFormate(data.URL)}>
                                <img src={REACT_APP_IMAGEURL+data.MobileLinkIcon} alt=""/> 
                                <span>{ReactHtmlParser(data.TitleText)}</span>
                            </a>
                        </li>
                    )
                })
            }
        </ul> 
    </div>
    </div>
    )
}

export default DreamSubMenuMobile;
